<div class="container">
    <h1 class="container text-center mt-3">Organigrama</h1>
    <hr class="mt-5 mb-5">
    <div class="col-sm-12 col-mg-12 col-lg-12">
        <img src="assets/img/organigrama.png" alt="" class="img-fluid">
    </div>
    <br>
</div>